import { render } from "./TasksList.vue?vue&type=template&id=3c5470ce&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-3c5470ce"

export default script